import { getUUID } from 'gyl-common/utils/uuid'
import upload from 'gyl-common/components/Uploader/utils/upload'

import { getSignature } from '@/services/cloudDisk'

const delay = ms => {
    // eslint-disable-next-line no-promise-executor-return
    return new Promise(resolve => setTimeout(resolve, ms))
}

// 签名控制器
class SignatureControl {
    signature = null

    _resolve = null
    _reject = null

    lock() {
        if (!this._resolve) {
            this._p = new Promise((resolve, reject) => {
                this._resolve = resolve
                this._reject = reject
            })
        }
    }

    unlock() {
        if (this._resolve) {
            this._resolve()
            this.clear()
        }
    }

    clear() {
        this._p = this._resolve = this._reject = null
    }

    static enqueueIfLocked(promise) {
        if (promise) {
            return promise
        }

        return Promise.resolve()
    }

    async refreshSignature() {
        try {
            const { success, data, now } = await getSignature()

            if (success) {
                const expire = Date.now() + (data.expire - now) - 2 * 60 * 1000 // 过期时间提前2分钟

                this.signature = {
                    ...data,
                    expire,
                }
            } else {
                this.signature = null
            }
        } catch (e) {
            console.error('catchError', e)
        }
    }

    checkSignature() {
        const { expire } = this.signature

        return Number(expire) >= Date.now()
    }

    async retry(count) {
        for (let i = 0; i < count; i++) {
            if (!this.signature || !this.checkSignature()) {
                await this.refreshSignature()
            } else {
                break
            }
        }
    }

    async getSignature() {
        if (this._p) {
            await SignatureControl.enqueueIfLocked(this._p)
        }

        this.lock()

        if (!this.signature || !this.checkSignature()) {
            await this.retry(1)
        }

        this.unlock()

        return this.signature
    }
}

const signatureCtrl = new SignatureControl()

const createCounter = () => {
    let count = 0

    const plus = () => {
        count += 1
    }

    const reset = num => {
        count = num
    }

    return {
        count,
        plus,
        reset,
        getCount() {
            return count
        },
    }
}

const counter = createCounter()

// 第247次的时候，速度陡降
const ALI_OSS_LIMIT_COUNT = 246

// temp为临时文件目录
export default async ({ file, fileSuffix = '', onProgress, onSuccess, onError }) => {
    // onProgress && onProgress({ percent: 0 })

    if (counter.getCount() >= ALI_OSS_LIMIT_COUNT) {
        // 冷却时间
        await delay(1000)
        counter.reset(1)
    } else {
        counter.plus()
    }

    const data = await signatureCtrl.getSignature()

    if (data) {
        const { dir, accessId, host, policy, signature, ossUrlDomain } = data

        const suffix = fileSuffix || file.name.slice(file.name.lastIndexOf('.')) || '.png'

        const { source = {}, width = 0, height = 0 } = file || {}
        const { type = '', size = 0 } = source

        const IS_IMAGE = type.indexOf('image/') !== -1
        const IS_IMAGE_VALID = IS_IMAGE && !(!size || !width || !height)

        let key = ''

        if (IS_IMAGE_VALID) {
            key = `${dir}${getUUID()}_s${size}_h${height}_w${width}${suffix}`
        } else {
            key = `${dir}${getUUID() + Date.now()}_s${size}${suffix}`
        }

        const addFileController = new AbortController()

        return new Promise(resolve => {
            const xhr = upload({
                action: host,
                filename: 'file', // ali oss 固定file
                file: file.source || file,
                ignoreToken: true,
                data: {
                    key,
                    OSSAccessKeyId: accessId,
                    policy,
                    Signature: signature,
                    success_action_status: '200',
                },
                onProgress(e) {
                    onProgress && onProgress(e)
                },
                onSuccess() {
                    const url = `${ossUrlDomain}${key}`

                    onSuccess({ url })
                },
                onError() {
                    onError && onError(new Error('上传失败'))

                    resolve({
                        abort() {
                            xhr.abort()
                            addFileController.abort()
                        },
                    })
                },
            })
        })
    } else {
        onError && onError(new Error('上传失败'))
    }
}
